import colorAlert from './tokens/_color-alert';
import colorBackground from './tokens/_color-background';
import colorBorder from './tokens/_color-border';
import colorBrand from './tokens/_color-brand';
import colorDataViz from './tokens/_color-dataviz';
import colorFont from './tokens/_color-font';
import colorInteraction from './tokens/_color-interaction';
import colorPrimitives from './tokens/_color-primitives';
import colorSecondary from './tokens/_color-secondary';
import colorShadow from './tokens/_color-shadow';
export const semanticCategoryMap = {
    alert: colorAlert,
    background: colorBackground,
    border: colorBorder,
    brand: colorBrand,
    dataViz: colorDataViz,
    font: colorFont,
    interaction: colorInteraction,
    primitives: colorPrimitives,
    secondary: colorSecondary,
    shadow: colorShadow,
};
/** Looks up a semantic color by name and category */
export function getSemanticColor(category, name) {
    var _a;
    const simpleCategoryMap = semanticCategoryMap;
    return (((_a = simpleCategoryMap[category]) === null || _a === void 0 ? void 0 : _a[name]) ? simpleCategoryMap[category][name] : null);
}
export { default as colorAlert } from './tokens/_color-alert';
export { default as colorBackground, } from './tokens/_color-background';
export { default as colorBorder } from './tokens/_color-border';
export { default as colorBrand } from './tokens/_color-brand';
export { default as colorDataviz } from './tokens/_color-dataviz';
export { default as colorFont } from './tokens/_color-font';
export { default as colorInteraction, } from './tokens/_color-interaction';
export { default as colorPrimitives, } from './tokens/_color-primitives';
export { default as colorSecondary } from './tokens/_color-secondary';
export { default as colorShadow } from './tokens/_color-shadow';
export { default as fontSize } from './tokens/_font-size';
export { default as layout } from './tokens/_layout';
//# sourceMappingURL=index.js.map